export const validateEmail=(email='')=>{
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  }

export const formatEmail=(str)=>{
return str.toLowerCase();
}